import { useSelector } from 'react-redux';
import { DISCOUNT_TYPES } from 'products/nomad_insurance/constants';

const useReferralDiscount = () => {
  const { planholder, isLoading } = useSelector(
    (state) => state.nomadInsurance.application
  );

  const discounts = planholder?.discounts || [];
  const referralDiscount = discounts.find(
    (discount) =>
      discount.discountType === DISCOUNT_TYPES.NI_C2C_REFERRAL ||
      discount.discountType === DISCOUNT_TYPES.NI_REACTIVATION_GIFT_CARD ||
      discount.discountType === DISCOUNT_TYPES.NI_GIFT_CARD
  );
  return { isOfferLoading: isLoading, referralDiscount };
};

export default useReferralDiscount;
